import { FC } from "react";
import { Spin } from "antd";

export const CustomFormLoading: FC = () => {
  return <Spin />;
};
